// extracted by css-extract-rspack-plugin
export default {"form":"oJUY71uW8N0MtkQF","label":"z58rb5no2lI5BFrP"};